import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Col, Image, Input, Row, Select } from "antd";
import ButtonGroup from "antd/es/button/button-group";
import { Option } from "antd/es/mentions";
import Modal from "antd/es/modal/Modal";
import moment from "moment";

import fileApi from "../../../../apis/File.api";
import notificationApi from "../../../../apis/Notification.api";
import nutrientsApi from "../../../../apis/Nutrients.api";
import { setLoading } from "../../../../redux/store/common/commonDuck";

const NutrientsRequestNutritionComponent = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const loading = useSelector((state) => state.common.loading);

  const setIsLoading = (value) => dispatch(setLoading(value));

  const imageBaseUrl = process.env.REACT_APP_S3_HOST + "/";
  let editNutrientsData = {};
  let editConfirmHistory = {};

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isCertifyModalVisible, setIsCertifyModalVisible] = useState(false);
  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const [error, setError] = useState("");
  const [reject_reason, setReject_reason] = useState("");
  const [not_name, setNot_name] = useState(null);
  const [reject_validation, setReject_validation] = useState(true);
  const [name_validation, setName_validation] = useState(true);
  const [fileList, setFileList] = useState([]);
  const [editState, setEditState] = useState(false);

  const [confirmHistory, setConfirmHistory] = useState({
    target_type: 3,
    confirm: 0,
    confirm_reason: "",
    target_id: props.match.params.id,
  });

  const [nutrientsData, setNutrientsData] = useState({
    category: "",
    name: "", //영양제명
    brand_name: "",
    brand_type: "",
    is_certify: "", //헬씨팀 인증 여부
    nutrition_facts: "", //분량
    nutrition_facts_unit: "", // 분량 단위
    energy: "", //칼로리(㎉)
    for_person: "", //인분 수
    for_person_unit: "", //인분 단위
    status: 0,
    created_at: "", //생성일
    created_by_name: user.nickname, //생성자
    created_by: user.id,
    updated_at: "", //수정일
    updated_by_name: user.nickname, //수정자
  });
  const contentName = {
    status: "상태",
    name: "영양제명",
    brand_type: "브랜드타입",
    is_certify: "헬씨팀 인증여부",
    nutrition_facts: "분량",
    nutrition_facts_unit: " 분량 단위",
    energy: "칼로리(㎉)",
    for_person: "인분 수",
    for_person_unit: "인분 단위",
  };

  const [nutrientsNutrition, setNutrientsNutrition] = useState({
    target_type: 3,
    target_id: props.match.params.id,
    total_dietary_fiber: 0, //	식이섬유
    calcium: 0, //	칼슘(mg)
    fe: 0, //	철(mg)
    magnesium: 0, //	마그네슘(mg)
    perfect_virtue: 0, //	인(㎎)
    potassium: 0, //	칼륨(㎎)
    zinc: 0, //	아연(mg)
    copper: 0, //	구리(mg)
    manganese: 0, //	망간(mg)
    selenium: 0, //	셀레늄(㎍)
    molybdenum: 0, //	몰리브덴(㎍)
    iodine: 0, //	요오드(㎍)
    vitamin_a: 0, //	비타민 A(㎍)
    beta_carotene: 0, //	베타카로틴
    vitamin_d: 0, //	비타민 D(μg)
    vitamin_e: 0, //	비타민 E(mg)
    vitamin_k: 0, //	비타민 K(㎍)
    vitamin_b1: 0, //	티아민(비타민 B1)(mg)
    vitamin_b2: 0, //	리보플라빈(비타민 B2)(mg)
    niacin: 0, //	나이아신(비타민 B3)mg NE
    pantothenic_acid: 0, //	판토텐산(비타민 B5)mg
    pyridoxine: 0, //	피리독신(비타민 B6)mg
    biotin: 0, //	비오틴(비타민 B7)
    folic_acid: 0, //	엽산(비타민 B9)μg
    vitamin_b12: 0, //	코발라민(비타민 B12)µg
    vitamin_c: 0, //	비타민 C(mg)
    omega_3_fatty_acids: 0, //	오메가3(mg)
    chrome: 0, //	크롬 ㎍
    guaranteed: 0, //	보장균수(억cfu)
    lutein: 0, //	루테인 mg
    zeaxanthin: 0, //	지아잔틴
    astaxanthin: 0, //	아스타잔틴mg
    silymarin: 0, //	실리마린 mg
    coq10: 0, //	CoQ10 mg
    ginsenoside: 0, //	진세노사이드mg
    flavonoids: 0, //	플라보노이드 mg
    theanine: 0, //	테아닌mg
    collagen: 0, //	콜라겐
    l_arginine: 0, //	L-라이신
    l_lysine: 0, //	L-아르기닌
    inositol: 0, //	이노시톨
    octacosanol: 0, //	옥타코사놀
    hca: 0, //	HCA
    udca: 0, //	UDCA
    γ_oryzanol: 0, //	γ-오리자놀
    glucosamine: 0, //	글루코사민
    betaglucan: 0, //	베타글루칸
    brewersyeast: 0, //	맥주효모
    oroticacidhydrate: 0, //	오로트산수화물
    hyaluronic_acid: 0, //	히알루론산mg
    glutamic_acid: 0, //	폴리감마글루탐산 mg
    msm: 0, //	MSM
    total_anthocyanosides: 0, //	총안토시아노사이드
    alpha_s_1_casein: 0, //	알파에스1카제인
    cultured_cells: 0, //	열처리배양균체 수
    rosabine: 0, //	로사빈
    lauric_acid: 0, //	로르산
    linolenic_acid: 0, //	감마리놀렌산(mg)
    catechins: 0, //	녹차추출물(카테킨)(mg)
    lactulose: 0, //	락추로스(mg)
  });

  const typeItems = [
    { typeType: "type", typeValue: 1, typeText: "영양제브랜드" },
  ];

  const certifyItems = [
    { certifyType: "is_certify", certifyValue: false, certifyText: "미인증" },
    // {certifyType: 'is_certify', certifyValue: true, certifyText: '인증'}
  ];

  const nutritionFactsUnitItems = [
    {
      nutritionUnitType: "nutrition_facts_unit",
      nutritionUnitValue: "mg",
      nutritionUnitText: "mg",
    },
    {
      nutritionUnitType: "nutrition_facts_unit",
      nutritionUnitValue: "g",
      nutritionUnitText: "g",
    },
    {
      nutritionUnitType: "nutrition_facts_unit",
      nutritionUnitValue: "ml",
      nutritionUnitText: "ml",
    },
  ];

  const forPersonUnitItems = [
    {
      personUnitType: "for_person_unit",
      personUnitValue: "g",
      personUnitText: "g",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "ml",
      personUnitText: "ml",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "듀얼포",
      personUnitText: "듀얼포",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "방울",
      personUnitText: "방울",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "병",
      personUnitText: "병",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "분사",
      personUnitText: "분사",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "정",
      personUnitText: "정",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "정제",
      personUnitText: "정제",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "캡슐",
      personUnitText: "캡슐",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "포",
      personUnitText: "포",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "회",
      personUnitText: "회",
    },
  ];

  const statusItems = [
    { statusType: "status", statusValue: 0, statusText: "신청" },
    { statusType: "status", statusValue: 1, statusText: "추가" },
  ];

  const getNutrientsData = async () => {
    setIsLoading(true);
    try {
      setError("");
      const res = await nutrientsApi.readNutrientsNutrition(
        props.match.params.id,
      );
      if (res.code === 200) {
        if (res.result.nutrients !== null) {
          setNutrientsData(res.result.nutrients);
          setNot_name(res.result.nutrients.name);
        }
        if (res.result.nutrients_nutrient !== null) {
          setNutrientsNutrition(res.result.nutrients_nutrient);
        }
        if (res.result.confirmHistory !== null) {
          setConfirmHistory(res.result.confirmHistory);
        }
        setIsLoading(false);
      } else {
        setIsLoading(false);
        window.alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      setError(error);
    }
  };

  const removeNutrientsData = async () => {
    setIsLoading(true); // 추가설정해야함. 팀장님거 참고하기.
    try {
      const res = await nutrientsApi.removeNutrients(props.match.params.id);
      if (res.code === 200) {
        setIsLoading(false);
        alert("영양제정보삭제가 완료되었습니다.");
        history.go(-1);
      } else {
        setIsLoading(false);
        alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      setError(error);
    }
  };

  const getImageFile = async () => {
    setIsLoading(true);
    try {
      const res = await fileApi.readFile(props.match.params.id, 3);
      if (res.code === 200) {
        setIsLoading(false);
        setFileList(res.result.fileList);
      } else {
        setIsLoading(false);
        alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      setError(error);
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };
  const showCertifyModal = () => {
    setIsCertifyModalVisible(true);
  };

  const showRejectModal = () => {
    setIsRejectModalVisible(true);
  };

  const handleOk = () => {
    removeNutrientsData();
    setIsModalVisible(false);
  };

  const handleRejectOk = () => {
    handleCancel();
    editNutrientsData = {
      ...nutrientsData,
      status: 0,
      updated_by: user.id,
      is_certify: false,
    };
    editConfirmHistory = {
      ...confirmHistory,
      confirm: 2,
      confirm_reason: reject_reason,
    };
    handleReject();
  };

  const handleCertifyOk = () => {
    handleCancel();
    editNutrientsData = {
      ...nutrientsData,
      status: 0,
      updated_by: user.id,
      is_certify: false,
    };
    editConfirmHistory = {
      ...confirmHistory,
      confirm: 1,
      confirm_reason: `덕분에 "${not_name}" 찾는 다른 유저 분들도 기록할 수 있게 되었네요!`,
    };
    handleCertify();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsCertifyModalVisible(false);
    setIsRejectModalVisible(false);
  };

  const handleClickEdit = (e) => {
    setEditState(true);
  };

  const handleClickCancel = () => {
    setEditState(false);
  };

  const handleClickComplete = async () => {
    setIsLoading(true);
    for (let i = 0; i < Object.keys(contentName)?.length; i++) {
      if (nutrientsData[Object.keys(contentName)[i]] === "") {
        return alert(Object.values(contentName)[i] + "을(를) 입력해주세요.");
      }
    }
    setNutrientsData({ ...nutrientsData, updated_by: user.id });
    try {
      const newEditNutrients = {
        nutrients: nutrientsData,
        nutrients_nutrient: nutrientsNutrition,
        confirmHistory: confirmHistory,
      };
      const res = await nutrientsApi.editNutrients(newEditNutrients);
      if (res.code === 200) {
        setIsLoading(false);
        window.alert("영양제정보수정 완료되었습니다.");
        getNutrientsData();
      } else {
        setIsLoading(false);
        window.alert("정상적인 요청이 아닙니다.");
      }
      setEditState(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      setError(error);
      setEditState(false);
    }
  };

  const onChange = (e) => {
    if (e.target.name === "nutrients") {
      setNutrientsData({ ...nutrientsData, [e.target.id]: e.target.value });
    } else if (e.target.name === "nutrientsNutrition") {
      setNutrientsNutrition({
        ...nutrientsNutrition,
        [e.target.id]: e.target.value,
      });
    } else {
      console.log("onChange Error", e.target.name);
    }
  };

  const onSelectChange = (value, e) => {
    setNutrientsData({ ...nutrientsData, [e.id]: value });
  };

  const handleRejectChange = (e) => {
    setReject_reason(e.target.value);
    if (e.target.value === "") {
      setReject_validation(true);
    } else {
      setReject_validation(false);
    }
  };

  const handleClickMenu = () => {
    history.go(-1);
  };

  const handleCertify = async () => {
    setIsLoading(true);
    try {
      const newEditNutrients = {
        nutrients: editNutrientsData,
        nutrients_nutrient: nutrientsNutrition,
        confirmHistory: editConfirmHistory,
      };
      const res = await nutrientsApi.editNutrients(newEditNutrients);
      if (res.code === 200) {
        const noti_res = await notificationApi.saveNotification({
          not_type: "NUTRIENTS_REQUEST",
          target_id: nutrientsData.created_by,
          not_title: `"${not_name}" 기록해 보세요!`,
          not_message: `신청하신 "${not_name}" 당신의 영양제에 등록되었어요!`,
          not_main_contents: `신청하신 "${not_name}" 등록되었어요!`,
          not_sub_contents: editConfirmHistory.confirm_reason,
          not_is_send: 0,
          created_by: user.id,
        });
        if (noti_res.code === 200) {
          window.alert("영양제 승인이 완료되었습니다.");
          getNutrientsData();
        }
      } else {
        window.alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
      setEditState(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      setError(error);
      setEditState(false);
    }
  };

  const handleReject = async () => {
    setIsLoading(true);
    try {
      setError("");
      const newEditNutrients = {
        nutrients: editNutrientsData,
        nutrients_nutrient: nutrientsNutrition,
        confirmHistory: editConfirmHistory,
      };
      const res = await nutrientsApi.editNutrients(newEditNutrients);
      if (res.code === 200) {
        const noti_res = await notificationApi.saveNotification({
          not_type: "NUTRIENTS_REQUEST",
          target_id: nutrientsData.created_by,
          not_title: `신청하신 "${not_name}" 결과가 왔어요!`,
          not_message: `당신의 영양제에서 신청 결과를 확인해 보세요!`,
          not_main_contents: `앗! 신청하신 "${not_name}"확인이 필요해요!`,
          not_sub_contents: editConfirmHistory.confirm_reason,
          not_is_send: 0,
          created_by: user.id,
        });
        if (noti_res.code === 200) {
          alert("영양제정보가 반려되었습니다.");
          getNutrientsData();
        }
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
      setEditState(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      setError(error);
      setEditState(false);
    }
  };

  const handleNameChange = (e) => {
    setNot_name(e.target.value);
    if (e.target.value === "") {
      setName_validation(true);
    } else {
      setName_validation(false);
    }
  };

  useEffect(() => {
    getNutrientsData();
  }, []);

  useEffect(() => {
    if (nutrientsData.status === 0) {
      getImageFile();
    }
  }, [nutrientsNutrition]);

  return (
    <div style={{ height: "auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <ButtonGroup style={{ marginTop: 10, display: "flex" }}>
          <Button
            style={{
              width: 100,
              height: 30,
              marginBottom: 20,
              borderColor: "#17721b",
            }}
            onClick={(e) => handleClickMenu(e)}
          >
            목록으로
          </Button>
        </ButtonGroup>
        <ButtonGroup
          style={{ marginTop: 10, marginRight: 30, display: "flex" }}
        >
          {confirmHistory.confirm === 0 && (
            <>
              <Button
                style={{
                  width: 100,
                  height: 30,
                  marginLeft: 20,
                  marginBottom: 20,
                  borderColor: "#00c5ff",
                }}
                onClick={showCertifyModal}
              >
                승인
              </Button>
              <Button
                style={{
                  width: 100,
                  height: 30,
                  marginLeft: 20,
                  marginBottom: 20,
                  borderColor: "#ff8900",
                }}
                onClick={showRejectModal}
              >
                반려
              </Button>
            </>
          )}
          <Button
            style={{
              width: 100,
              height: 30,
              marginLeft: 20,
              marginBottom: 20,
              borderColor: "#ff0000",
            }}
            onClick={showModal}
          >
            {" "}
            삭제하기{" "}
          </Button>
        </ButtonGroup>
      </div>

      <Modal
        title="영양제정보삭제"
        visible={isModalVisible}
        maskClosable={false}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>정말로 해당 영양제정보를 삭제하시겠습니까?</p>
      </Modal>

      <Modal
        title="영양제정보 승인"
        visible={isCertifyModalVisible}
        maskClosable={false}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel} loading={loading}>
            돌아가기
          </Button>,
          <Button
            key="uploadSubmit"
            type="primary"
            loading={loading}
            disabled={name_validation}
            onClick={handleCertifyOk}
          >
            승인하기
          </Button>,
        ]}
      >
        <h2>해당 영양제정보를 승인하시겠습니까?</h2>
        <div className="modal-input-wrap">
          알림 영양제명 :{" "}
          <input
            className="input-reject-wrap"
            placeholder="영양제명을 적어주세요!"
            onChange={handleNameChange}
          />
        </div>
        <p>(지정된 알림이 함께 발송됩니다.)</p>
      </Modal>

      <Modal
        title="영양제정보 반려"
        visible={isRejectModalVisible}
        maskClosable={false}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel} loading={loading}>
            돌아가기
          </Button>,
          <Button
            key="uploadSubmit"
            type="primary"
            loading={loading}
            disabled={reject_validation && name_validation}
            onClick={handleRejectOk}
          >
            반려하기
          </Button>,
        ]}
      >
        <h2>해당 영양제정보를 반려하시겠습니까?</h2>
        <div className="modal-input-wrap">
          알림 영양제명 :{" "}
          <input
            className="input-reject-wrap"
            placeholder="영양제명을 적어주세요!"
            onChange={handleNameChange}
          />
        </div>
        <div className="modal-input-wrap">
          반려사유 :{" "}
          <input
            className="input-reject-wrap"
            placeholder="반려 사유를 입력해주세요!"
            onChange={handleRejectChange}
          />
        </div>
      </Modal>

      <Row>
        <Col span={24}>
          <Row>
            <Col className="request-content-wrap" span={15}>
              <Row>
                <Col className="food-request-content">
                  <p> 신청내용</p>
                  <pre>{nutrientsData.name}</pre>
                </Col>
              </Row>
            </Col>
            <Col span={8} offset={1}>
              <Row>
                <Col span={24} className="food-request-detail">
                  <div className="request-detail-col">
                    <div className="request-detail-wrap">
                      <div>생성자</div>
                      <div>
                        {nutrientsData.created_by_name
                          ? nutrientsData.created_by_name
                          : "Admin"}
                      </div>
                    </div>
                    <div className="request-detail-wrap">
                      <div>생성일</div>
                      <div>
                        {nutrientsData.created_at === null
                          ? "-"
                          : moment(nutrientsData.created_at).format(
                              "YYYY-MM-DD",
                            )}
                      </div>
                    </div>
                  </div>

                  <div className="request-detail-col">
                    <div className="request-detail-wrap">
                      <div>수정자</div>
                      <div>
                        {nutrientsData.updated_by_name
                          ? nutrientsData.updated_by_name
                          : "Admin"}
                      </div>
                    </div>
                    <div className="request-detail-wrap">
                      <div>수정일</div>
                      <div>
                        {nutrientsData.updated_at === null
                          ? "-"
                          : moment(nutrientsData.updated_at).format(
                              "YYYY-MM-DD",
                            )}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <div>
        {confirmHistory.confirm === 1 ? "승인사유" : "반려사유"}
        <p>{confirmHistory.confirm_reason}</p>
      </div>
      {nutrientsData.status === 0 ? (
        <Col span={24} style={{ marginTop: 30 }}>
          <Row>
            <h1> * 첨부사진 </h1>
          </Row>
          <Row>
            <Col span={6} offset={1} style={{}}>
              {fileList[0] === undefined ? (
                <div>첨부된 사진이 존재하지 않습니다.</div>
              ) : (
                <Image src={`${imageBaseUrl}${fileList[0].file_path}`} />
              )}
            </Col>
            <Col span={6} offset={2}>
              {fileList[1] === undefined ? (
                <></>
              ) : (
                <Image src={`${imageBaseUrl}${fileList[1].file_path}`} />
              )}
            </Col>
            <Col span={6} offset={2}>
              <Row>
                {fileList[2] === undefined ? (
                  <></>
                ) : (
                  <Image src={`${imageBaseUrl}${fileList[2].file_path}`} />
                )}
              </Row>
            </Col>
          </Row>
        </Col>
      ) : (
        console.log()
      )}
    </div>
  );
};

export default NutrientsRequestNutritionComponent;
